import { Phone, MessageCircle } from "lucide-react";
import { WHATSAPP_URL, CALL_URL, trackWhatsAppClick, trackCallClick } from "@/lib/constants";

export default function StickyCtAs() {
  return (
    <div data-testid="sticky-ctas" className="fixed bottom-5 right-5 z-50 hidden sm:flex flex-col gap-3">
      <a
        href={WHATSAPP_URL}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="sticky-whatsapp-btn"
        onClick={trackWhatsAppClick}
        className="w-14 h-14 rounded-full bg-[#25D366] hover:bg-[#1da851] text-white flex items-center justify-center shadow-lg animate-pulse-glow transition-colors"
        aria-label="WhatsApp"
      >
        <MessageCircle className="w-6 h-6" />
      </a>
      <a
        href={CALL_URL}
        data-testid="sticky-call-btn"
        onClick={() => trackCallClick(CALL_URL)}
        className="w-14 h-14 rounded-full bg-[#b22300] hover:bg-[#8a1b00] text-white flex items-center justify-center shadow-lg transition-colors"
        aria-label="Call"
      >
        <Phone className="w-6 h-6" />
      </a>
    </div>
  );
}
